module.exports = __webpack_public_path__ + "static/media/tv.f6efd705.svg";